import React, { useState, useContext }			from 'react';
import { Link}				from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner, Dropdown, InputGroup} from "react-bootstrap";
import atlasApi				from "../utils/atlasapi";
import {formatDate, norm}			from "../utils/functions";
import Pagination			from "../components/Pagination";
import Filter				from "../components/Filter";
import ScenarioTag				from "../components/ScenarioTag";
import globalContext		from "../utils/globalContext";
import { X, Plus, DotsThreeVertical, PencilLine, Trash, BookOpen, PencilSimple, DownloadSimple, Copy} from "@phosphor-icons/react";

import DataTable, { createTheme }	from 'react-data-table-component';
import DialogDeleteScenario			from "../layouts/DialogDeleteScenario";
import DialogDownloadScenario		from "../layouts/DialogDownloadScenario";
import DialogSaveScenario			from "../layouts/DialogSaveScenario";
import DialogSetMain				from "../layouts/DialogSetMain";
import DialogScenario				from "../layouts/DialogScenario";




	
export default function DialogScenarioManage({
	scenarios,
	setup,
	onClose,
	onChangeScenario
}){
	const scenarioOpts = [
		{label:'Overview', value:'all'},
		{label:'Yours', value:'mine'},
	];
		
	const [typeFilter,setTypeFilter]					= useState(scenarioOpts[0]);
	const [data,setData]								= useState(scenarios);
	const [deleteScenario,setDeleteScenario]			= useState({open:false}); //displays delete scenario dialog if true
	const [downloadScenario,setDownloadScenario]		= useState({open:false}); //displays save scenario dialog if true
	const [saveScenario,setSaveScenario]				= useState({open:false}); //displays save scenario dialog if true
	const [setMain,setSetMain]							= useState({open:false}); //displays set main scenario dialog
	const [copyScenario,setCopyScenario]				= useState({open:false}); //displays copy scenario dialog if true
	const [needle, setNeedle]							= useState('');
	
	const context = useContext(globalContext);

	createTheme(
		'vlist',
		{
			background: {
				default: 'transparent',
			},
			headRow: {

			}
		},
		'light',
	);
	

	const handleRowsPerPageChange = (rows) => {
		//saveRows(rows);
	}
	
	const handleClose  = (e) => {
		
		if(onClose)
			onClose(data);
		
	}

	const handleOnShow  = () => {
		
	}
	const handleChangeFilter = (a) => {
		
		const filter = a[0];
		
		
		setTypeFilter(a[0]);
		
		if(filter.value == 'mine'){
			const d = scenarios.filter((a)=>{
				return a.created_by.email == context.getters.user.userDetails;
			});
			setData(d);
		}
		else {
			setData(scenarios);
		}	
	}
	
	const handleDeleteScenario = (scenario) => {
		
		setDeleteScenario({open:true, scenario:scenario, user:context.getters.user,  stack:true, onClose: () => {
			
			var newData = data.slice(0);
			var idx = data.findIndex((s)=>{
				return s.scenarioid == scenario.scenarioid;
			});
			if(idx != -1){
				newData.splice(idx, 1);
				setData(newData);
			}
		}});
		
	}
	const handleDuplicateScenario = (row) => {
		setCopyScenario({
			open:true, 
			user:context.getters.user, 
			selected:{value:row.scenarioid, label:row.name}, 
			projectid:setup.projectid, 
			options: data.map((s)=>{return {label:s.name, value:s.scenarioid}}), 
			versionid:0,
			onFinish: null
		});
	}
	
	const handleSetMain = (scenario) => {
		setSetMain({open:true, scenario:scenario, user:context.getters.user});
	}

	const handleRenameScenario = (scenario, rename) => {
		
		setSaveScenario({open:true, scenario:scenario, user: context.getters.user, rename:true, onAfter:(resultScenario)=>{
			if(!resultScenario)
				return;
			const scenarioid = resultScenario.scenario_id ?? resultScenario.scenarioid;
			
			//update scenario in the scenario manager list
			var newScenarios = [...data];
			newScenarios.forEach((s)=>{
				if(s.scenarioid == scenarioid)
					s.name = resultScenario.name;
			});
			
			//update scenario info in project scenarios array
			var newpd = {...context.getters.project};
			
			newpd.scenarios.forEach((s)=>{
				if(s.scenarioid == scenarioid)
					s.name = resultScenario.name;
			});
			context.setters.setProject(newpd);
			
			
			setData(newScenarios);
		}});
	}
	
	const handleDownload = (row) => {
		
		setDownloadScenario({open:true, scenario:row, stack:true});
		
	}
	const handleRowClick = (row) => {
		
		if(onChangeScenario){
			onChangeScenario({label:row.name, value:row.scenarioid});
			handleClose();
		}
		
	}
	const handleSearch = (a) => {
		
		if(a.target.value.length>2 || !a.target.value.length) {
			setNeedle(new RegExp(a.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), "i"));
		}
	};
	
	const applySearch = (data) => {
		
		return data.filter(searchNeedle);
		
		
	}
	const searchNeedle = (item) => {
		
		if(needle.length < 3)
			return true;
		
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(
			item.name && norm(item.name).match(needle)
			||
			item.created_by && item.created_by.email && norm(item.created_by.email).match(needle)
			||
			item.created_by && item.created_by.name && norm(item.created_by.name).match(needle)
		)
	}
	
	
	
	return (
		<>
			<DialogDeleteScenario	setup={deleteScenario}		onClose={()=>{setDeleteScenario({open:false})}} />
			<DialogDownloadScenario setup={downloadScenario}	onClose={()=>{setDownloadScenario({open:false});}} />
			<DialogSaveScenario		setup={saveScenario}		onClose={()=>{setSaveScenario({open:false});}} />
			<DialogSetMain			setup={setMain}				onClose={()=>{setSetMain({open:false});}} />
			<DialogScenario			setup={copyScenario}		onClose={()=>{setCopyScenario({open:false})}} />
			
			<Modal className="scenario-manage" show={setup.open} onShow={handleOnShow} centered>
				<Modal.Header>
					<Modal.Title>All Scenarios</Modal.Title>
					<span onClick={handleDuplicateScenario} className="btn btn-primary btn-sm ms-auto"><Plus size={16} /> New scenario</span>
					<span onClick={handleClose} className="btn btn-close alt float-end"><X size={16} /></span>

				</Modal.Header>
				<Modal.Body>
						<Row className=" row-tabs">
							<Col xs="12" className="scenario-filters">
								<Filter options={scenarioOpts} defaultValue={[typeFilter]} onChange={(a)=>{ handleChangeFilter(a);}}/>
							</Col>
						</Row>
				</Modal.Body>
				<Modal.Body className="dark">
					<div>
						<Row className="p-3 filters">		
							<Col xs="3">
								<InputGroup>
									<Form.Control autoFocus  type="text" className="search-input" onChange={handleSearch} placeholder="Search projects..." />
									<InputGroup.Text id="basic-addon1"><i className="ri-search-line"></i></InputGroup.Text>
								</InputGroup>
							</Col>



						</Row>
						<DataTable
							data={applySearch(data)}
							columns={[
								{
									name:'Scenario',
									selector: row => row.name,
									format: (row) =>  row.name,
									minWidth:"300px"
								},
								{
									name:'Last edited',
									selector: row => row.updated,
									format: (row) =>  (formatDate(row.updated, 'dotted-full'))
								},
								{
									name:'Last edited by',
									selector: row => row.updated_by.name,
									format: row => row.updated_by.name,
								},
								{
									name: 'Created',
									selector: row => row.created,
									format: (row) =>  (formatDate(row.created, 'dotted-full'))
								},
								{
									name: 'Created by',
									selector: row => row.created_by.name,
									format: row => row.created_by.name,
								},
								{
									name: 'Tags',
									selector: row => row.tags,
									format: row => <ScenarioTag scenario={row} />,
								},
								{
									name:'',
									id:'contextmenu',
									cell: row => (
										<div className="context-menu">
											<Dropdown className="minimal">
												<Dropdown.Toggle className="p-0 px-1" variant="default">
													<DotsThreeVertical size={16} />
												</Dropdown.Toggle>
												<Dropdown.Menu>
												
														<Dropdown.Item href="#" onClick={(e)=>{handleDuplicateScenario(row);}} className="details"><Copy size={14} /> Duplicate</Dropdown.Item>
														<Dropdown.Item href="#" onClick={(e)=>{handleSetMain(row);}} disabled={!row.scenarioid || !context.getters.user.userDetails}  className="details"><PencilSimple size={14} /> Set as Main</Dropdown.Item>
														<Dropdown.Item href="#" onClick={(e)=>{handleRenameScenario(row, true);}} disabled={!row.scenarioid} className="important"><PencilSimple size={14} /> Edit scenario</Dropdown.Item>
														<Dropdown.Item href="#" onClick={(e)=>{handleDownload(row);}} className="important"><DownloadSimple size={14} /> Download</Dropdown.Item>
														<Dropdown.Item href="#" onClick={(e)=>{handleDeleteScenario(row);}} disabled={!row.scenarioid} className="share text-danger"><Trash size={14} /> Delete</Dropdown.Item>
														
												</Dropdown.Menu>
											</Dropdown>
										</div>
									),
									width:"40px",
								}

							]}
							theme="vlist"
							customStyles={{
								headCells:{
									style: {
										fontWeight:'bold'
									}
								},
							}}

							pagination
							onRowClicked={(row)=>{handleRowClick(row);}}
							onChangeRowsPerPage={handleRowsPerPageChange}
							paginationComponent = {Pagination}
							paginationComponentOptions = {{
								rowsPerPageText: 'Show',
								type: 'scenarios',
								hideRowsPerPage: true,
								rangeSeparatorText: 'of',
								selectAllRowsItemText: 'All',
							}}

						/>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);

}